import 'unfonts.css';
import 'virtual:svg-icons-register';
import '@/css/app.pcss';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/nb';
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import barba from '@barba/core';

dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.locale('nb');
Alpine.plugin(mask);
window['dayjs'] = dayjs;
window['barba'] = barba;

const secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    return {
        'h': hours,
        'm': minutes,
        's': seconds
    };
};
window['secondsToTime'] = secondsToTime;

const validateEmail = (email = null) => {
    if (!email) return false;
    const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return !!email.match(mailformat);
};
window['validateEmail'] = validateEmail;

const distanse = (index = null) => {
    const distanser = ['500m', '500m', '1000m', '1000m', '2000m'];
    return index !== null ? distanser[index] : distanser;
};
window['distanse'] = distanse;
let csrf = null;
window['app'] = {
    initPage(registrering = null, start = null, gjennomfor = null, stengt = null) {
        return {
            registrering: registrering,
            aktivt: start ?? '2025-04-01',
            gjennomfor: gjennomfor ?? stengt,
            stengt: stengt ?? '2025-05-09 23:59',
            isLoading: false,
            user: {},
            modal: {
                name: false
            },
            async init() {
                this.checkNav();
                barba.init({
                    // debug:true,
                    timeout: 5000,
                    cacheIgnore: true,
                    prefetchIgnore: true,
                    transitions: [
                        {
                            once: async () => {
                                await this.hentUser();
                            },
                            beforeLeave: () => {
                            },
                            leave: () => {
                                // console.log('leave');
                                this.isLoading = true;
                            },
                            beforeEnter: async data => {
                                const from = new URL(data.current.url.href);
                                if (!csrf || !this.user?.id) {
                                    await this.hentUser();
                                }
                            },
                            enter: data => {
                                // console.log('enter');
                                // console.log(data);
                                const html = new DOMParser().parseFromString(
                                    data.next.html,
                                    'text/html'
                                );
                                document.title = html.title;

                                /*const nav = html.querySelector('nav');
                            if(nav) {
                                document.querySelector('nav').innerHTML = nav.innerHTML;
                            }*/
                            },
                            afterEnter: () => {
                                window.scrollTo({ top: 0 });
                                this.isLoading = false;
                                this.checkNav();
                                this.modal.name = !this.user.name;
                            },
                            after: () => {
                                // console.log('after');
                                // this.felles();
                            }
                        }
                    ]
                });
            },
            checkNav() {
                const activePage = window.location.pathname;
                document.querySelectorAll('nav a').forEach(link => {
                    link.classList.remove('active');
                    const url = new URL(link.href);

                    if (url.pathname == activePage) {
                        link.classList.add('active');
                        // console.log(link);
                    }
                });
            },
            async hentUser() {
                try {
                    const json = await (
                        await fetch('/api/me', {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json'
                            }
                        })
                    ).json();
                    this.user = json;
                    csrf = json.csrf;
                } catch (error) {
                    console.error('Error:', error);
                }
            },
            get tidIgjen() {
                return dayjs().to(this.stengt);
            },
            get showStengtVarsel() {
                return dayjs().isBetween(dayjs(this.stengt).subtract(1, 'day'), dayjs(this.stengt));
            },
            aapent(vedRegistrering: Boolean = false) {
                const aktiv = dayjs().isAfter(vedRegistrering ? this.registrering : this.aktivt),
                    stengt = dayjs().isBefore(this.stengt);
                console.log(this.aktivt, aktiv, this.stengt, stengt);
                return aktiv && stengt;
            }
        };
    },
    initLoper() {
        return {
            sender: false,
            user: null,
            visRegistrer: false,
            async sok({ id = null, email = null }) {
                let params = new URLSearchParams('');
                if (id) {
                    params.append('id', id);
                }
                if (email) {
                    params.append('email', email);
                }

                if (!id && !email) return;

                try {
                    this.visRegistrer = false;
                    this.sender = true;
                    const { data } = await (await fetch(`/api/loper?${params.toString()}`)).json();
                    this.visRegistrer = !data;
                    this.user = data;
                } catch (e) {
                    console.log(e);
                }
                this.sender = false;
            }
        };
    },
    initLag(id = null) {
        return {
            sender: false,
            lag: null,
            async edit() {
                if (!id) {
                    this.lag = {
                        etapper: Array(5)
                    };
                    return false;
                }
                try {
                    this.sender = true;
                    const { data } = await (await fetch(`/api/lag?id=${id}`)).json();
                    this.lag = data[0] || null;
                    // this.lag = null;
                    // this.$nextTick(() => this.lag = data[0] || null);
                } catch (e) {
                    console.log(e);
                }
                this.sender = false;
            },
            async alleLag() {
                try {
                    this.sender = true;
                    const { data } = await (await fetch(`/api/alle-lag`)).json();
                    this.lag = data || null;
                } catch (e) {
                    console.log(e);
                }
                this.sender = false;
            },
            async mineLag() {
                try {
                    this.sender = true;
                    const { data } = await (await fetch(`/api/mine-lag`)).json();
                    this.lag = data;
                } catch (e) {
                    console.log(e);
                }
                this.sender = false;
            },
            samletTid(sec) {
                const tid = secondsToTime(sec);
                return `${tid.h.toString().padStart(2, '0')}:${tid.m
                    .toString()
                    .padStart(2, '0')}:${tid.s.toString().padStart(2, '0')}`;
            }
        };
    },
    initLogOut() {
        return {
            sender: false,
            async logOut(redirectUri: string = '/stafett') {
                try {
                    this.sender = true;
                    await fetch('/logout', {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-Token': csrf
                        }
                    });
                    csrf = null;
                    barba.go(redirectUri);
                } catch (e) {
                    console.error(e);
                }
                this.sender = false;
            }
        };
    },
    initSkjema() {
        return {
            sender: false,
            errors: [],
            async send() {
                if (this.sender) return;
                this.sender = true;
                this.errors = [];
                const params = new FormData(this.$el);
                const action = this.$el.getAttribute('action') || '/';
                const json =
                    (await (
                        await fetch(action, {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-Token': csrf
                            },
                            body: params
                        })
                    ).json()) || [];
                this.sender = false;
                console.log(json);
                if (json.success) {
                    this.$dispatch('success', json);
                } else if (json.error) {
                    this.errors = [json.error.message || json.error];
                } else if (json.errors) {
                    console.error(json.errors);
                    this.errors = json.errors;
                }
            }
        };
    }
};

Alpine.start();
